
import React, {useEffect, useState } from 'react';

import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Radio,
  Rate,
  Row,
  Select,
  Slider,
  Switch,
  Upload,
  Drawer,
  message
} from 'antd';


import { FileAddOutlined,InboxOutlined, UploadOutlined } from '@ant-design/icons';

import {API_BASE_V2,dfuUpload} from './../../services';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const normFile = (e) => {
  console.log('Upload event:', e);
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};



const NewFirmware = (props) => {
  const { Dragger } = Upload;
  const [open, setOpen] = useState(false);
  const [swValue, setSWValue] = useState('');
  const [hwValue, setHWValue] = useState('');
  const [fileList, setFileList] = useState([]);
  const [status, setStatus] = useState(true);
  const [form] = Form.useForm();


 const handleStatusChange = (state) =>{
    setStatus(state);
 }
  const handleSWChange = (e) => {
    setSWValue(e.target.value);
  };
  const handleHWChange = (e) => {
    setHWValue(e.target.value);
  };

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };


  const onFinish = async (values) => {
      await dfuUpload(values);
      console.log('Received values of form: ', values);
  };


const uploadProps = {
  name: 'file',
  multiple: false,
  action: API_BASE_V2+"/api/firmware/upload",
  onChange(info) {
    const { status } = info.file;
    if (status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};


  const beforeUpload = (file) => {
    // Add the file to the fileList to display it
    setFileList([...fileList, file]);
    return false; // Prevent automatic upload
  };

const handleCustomRequest = async (options) => {
    const { onSuccess, onError, file } = options;

    // Simulate an asynchronous upload process (e.g., sending the file to the server)
    try {
      // Replace this with your actual API endpoint and data format

      let thisRequest ={};

        if(swValue===""  && hwValue===""){
          
          onError(response.error || 'S/W & H/W  Input is Empty');

          return;
        }

      thisRequest.file  = file;
      thisRequest.sw_value = swValue;
      thisRequest.hw_value = hwValue;
      thisRequest.status = status;  


      const response = await yourUploadApi(thisRequest);

      // Check for success in the response (customize this based on your API)
      if (response.status === 'success') {
        onSuccess(response, file);
        message.success('File uploaded successfully');
         form.resetFields();
        props.syncTrigger();
        setOpen(false);

      } else {
        onError(response.error || 'Upload failed');
        message.error('File upload failed');
      }
    } catch (error) {
      onError(error || 'Upload failed');
      if(swValue===""  && hwValue===""){
         message.error('S/W & H/W  Input is Empty');
      } else {
        message.error('File upload failed');
      }
    }
  };

  // Replace this function with your actual upload API logic
  const yourUploadApi = async (req) => {
    // Perform the file upload here, and return the API response
    // You can use libraries like axios or fetch to make the actual API request
    // Example using fetch:
    const formData = new FormData();
    formData.append('file', req.file);
    formData.append('hw_value', req.hw_value);
    formData.append('sw_value', req.sw_value);
    formData.append('status', req.status);
    
    const response = await fetch(API_BASE_V2+"/api/firmware/upload", {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Upload failed');
    }

    

    return response.json();
  };



  return (
    <>
      <Button type="primary"
        style={{
          marginBottom: 15,
          backgroundColor:"#4caf50",
          border:"none",
        }}
        icon={<FileAddOutlined/>}  onClick={showDrawer}>
        New DFU
      </Button>
      <Drawer width={768} className="settings-drawer" title="Add New DFU"  mask={true}
           placement="right" onClose={onClose}  closable={true} visible={open}>


           <Form
      name="validate_other"
      {...formItemLayout}
      form={form} 
      onFinish={onFinish}
       initialValues={{
          dfu_status: true,
      }}
      
    >
    
          <Form.Item
        {...formItemLayout}
        name="sw_version"
        label="S/W Version"
        rules={[
          {
            required: true,
            message: 'Please input S/W Version',
          },
        ]}
      >
        <Input onChange={handleSWChange} placeholder="Please input S/W Version" />
      </Form.Item>
     
        <Form.Item
        {...formItemLayout}
        name="hw_version"
        label="H/W Version"
        rules={[
          {
            required: true,
            message: 'Please input H/W Version',
          },
        ]}
      >
        <Input  onChange={handleHWChange} placeholder="Please input H/W Version" />
      </Form.Item>
     

{/*
      <Form.Item name="dfu_status" label="Status" valuePropName="checked" >
        <Switch  onChange={handleStatusChange} />
      </Form.Item>*/}


    
    

     
      <Form.Item label="DFU File">
        <Form.Item name="files"  noStyle>
         <Upload.Dragger maxCount={1} name="files"   customRequest={handleCustomRequest}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
          </Upload.Dragger>

      

        </Form.Item>
      </Form.Item>

      <Form.Item
        wrapperCol={{
          span: 12,
          offset: 6,
        }}
      >
       
      </Form.Item>
    </Form>


         {/*  <div style ={{height:"300px"}}>
           
        </div>*/}
        
      </Drawer>
    </>
  );
};


export default NewFirmware;